import { create } from "zustand";
import API from "../axios/API";
import { getToken, removeToken, setToken } from "@/helpers";

const initialState = {
  isAuthenticated: false,
  isAuthenticating: true,
  persistedPathname: null,
};

const restrictPathnamesArr = ["referral", "invitation", "register"];

const isDesiredLocationForUnauthenticated = (location) => {
  return restrictPathnamesArr.some((pathname) =>
    location.pathname.includes(pathname),
  );
};

const verifyToken = async (token) => {
  try {
    const res = await API.post("/token-verify/", { token });
    if (res.status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
};

const useAuthStore = create((set, get) => ({
  ...initialState,

  initAuthStore: async (location) => {
    const token = getToken();
    if (!token) {
      return set({
        persistedPathname: location.pathname,
        isAuthenticating: false,
        isAuthenticated: false,
      });
    }

    // if there is a user signed in, but the initial location is to one of the referral/invitation/register forms..
    // sign the user out and allow the routing to unauthenticated page.
    if (isDesiredLocationForUnauthenticated(location)) {
      removeToken();
      return set({
        isAuthenticated: false,
        isAuthenticating: false,
      });
    }

    const tokenIsVerified = await verifyToken(token);
    if (tokenIsVerified) {
      set({
        isAuthenticating: false,
        isAuthenticated: true,
      });
    } else {
      removeToken();
      set({
        persistedPathname: location.pathname,
        isAuthenticating: false,
        isAuthenticated: false,
      });
    }
  },
  clearPersistedPath: () => {
    set({
      persistedPathname: null,
    });
  },
  login: async (token, navigate) => {
    setToken(token);
    set({
      isAuthenticated: true,
    });
    navigate("/");
  },
  logout: (queryClient) => {
    removeToken();
    set({
      isAuthenticated: false,
    });

    if (queryClient) {
      queryClient.clear();
    }
  },
  handle401: () => {
    removeToken();
    set({
      isAuthenticated: false,
    });
  },
}));

export default useAuthStore;
